module.exports = __webpack_public_path__ + "img/64_1.66b3736c.png";